import { RequestService } from '../../../common/services/RequestService';
import { SET_VIEW_LOG } from '../constants';

export const deleteViewLogRequest = async (
  profileId,
  payload,
  entity = null
) => {
  if (entity) {
    payload = { entity: entity, entity_id: payload };
  }
  const response = await RequestService.delete(SET_VIEW_LOG + profileId, {
    data: payload,
  });
  return response;
};
